const fromIsolationGroupsV2 = (isolationGroups) => isolationGroups.map((val) => ({
  Id: val.id,
  Name: val.displayName,
  Hidden: val.isArchived
}));
export {
  fromIsolationGroupsV2
};
//# sourceMappingURL=IsolationGroupUtils.js.map
